import { useInlineBanner } from '@/context/InlineBannerContext';
import { cn } from '@/lib/utils';
import { Info, CheckCircle2, AlertTriangle } from 'lucide-react';

const ICON_MAP = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
} as const;

/**
 * Inline banner rendered directly below the topbar.
 * Takes layout space (pushes content down). Auto-dismisses.
 * Calm, Farmly-toned – no harsh colors.
 */
export function InlineBanner() {
  const { banner, dismissBanner } = useInlineBanner();

  if (!banner) return null;

  const variant = banner.variant ?? 'info';
  const Icon = ICON_MAP[variant];

  return (
    <div
      role="status"
      aria-live="polite"
      onClick={dismissBanner}
      className={cn(
        'flex items-center gap-2 px-4 py-2.5 text-sm cursor-pointer transition-all',
        'border-b border-border/40 bg-muted/50 text-muted-foreground',
        'animate-in slide-in-from-top-1 fade-in duration-300',
      )}
    >
      <Icon className="h-3.5 w-3.5 shrink-0 opacity-60" />
      <span className="truncate">{banner.message}</span>
    </div>
  );
}
